import React from "react"
import "./LabeledInput.css"

const LabeledInput = props => {
  const {
    label,
    iconText,
    iconPosition,
    textPosition,
    className,
    fluid,
    ...rest
  } = props
  return (
    <div>
      <label>{label}</label>
      <div className={`ui right labeled ${fluid ? "fluid " : ""}input`}>
        {iconPosition === "left" && (
          <div className="ui basic label label">{iconText}</div>
        )}
        <input
          {...rest}
          style={{ textAlign: textPosition === "left" ? "left" : "right" }}
          autoComplete="off"
          className={`${className}`}
        />
        {iconPosition !== "left" && (
          <div className="ui basic label label">{iconText}</div>
        )}
      </div>
    </div>
  )
}

export default LabeledInput
